import { render, staticRenderFns } from "./inquiryDetail.vue?vue&type=template&id=45510b6a&scoped=true"
import script from "./inquiryDetail.vue?vue&type=script&lang=js"
export * from "./inquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetail.vue?vue&type=style&index=0&id=45510b6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45510b6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45510b6a')) {
      api.createRecord('45510b6a', component.options)
    } else {
      api.reload('45510b6a', component.options)
    }
    module.hot.accept("./inquiryDetail.vue?vue&type=template&id=45510b6a&scoped=true", function () {
      api.rerender('45510b6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/inquiryDetailsPopupChild/inquiryDetail.vue"
export default component.exports